export default {
    name: "Ethereum Classic",
    coin: "ETC",
    scheme: "SOLO",
    account: '0x2b2c7660a665fe35feaa47317a8bd95f543c188d',
    explorer_url: 'https://etc.blockscout.com',
    coingecko: 'https://www.coingecko.com/en/coins/ethereum-classic',
    explorer: {
        address: "https://etc.blockscout.com/address/",
        height: "https://etc.blockscout.com/block/",
        hash: "https://etc.blockscout.com/block/",
        tx: "https://etc.blockscout.com/tx/",
    },
    ports: [
        {
            info: "LOW",
            host: "molepool.com",
            port: 4444,
            diff: 2,
        },
        {
            info: "MID",
            host: "molepool.com",
            port: 4422,
            diff: 8,
        },
        {
            info: "HIGH",
            host: "molepool.com",
            port: 4440,
            diff: 16,
        }
    ]
};